var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"p-flex coordinate form-group"},[_c('coordinates-input',{model:{value:(_vm.coords),callback:function ($$v) {_vm.coords=$$v},expression:"coords"}}),_c('b-button',{attrs:{"variant":"outline-primary"},on:{"click":_vm.search}},[_c('b-icon',{attrs:{"icon":"search"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }